import { useStorage } from '@vueuse/core';
import { ACCESS_TOKEN_KEY } from '@/enums/cacheEnum';

export const storageToken = useStorage(ACCESS_TOKEN_KEY, '');

export const storageIsLogin = useStorage('isLogin', false);
export const storageAppVersion = useStorage('appVersion', '');
